import React, { useState } from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import PropTypes from 'prop-types';
import Grid from '../../Utils/GridVDocumento';
import moment from 'moment';
import NumberFormat from 'react-number-format';
import classNames from 'classnames';
import styled from 'styled-components';
import TablaDetalleMod from './ChequesDetalleMod';
import TablaDetalle from './ChequesDetalle';
import TablaVerDetalle from './ChequesVerDetalle';
import Swal from 'sweetalert2';
import {
    renderDayPickerB,
    renderField,
    renderNumber,
    SelectField,
    AsyncSelectField,
    renderFieldCheck,
    renderCurrencyFloat,
    renderCurrencyFloatTC,
    AsyncSelectFieldIn

} from "../../Utils/renderField/renderField";


function ChequesForm(props) {
    const { crear, lectura, editar, detalleCK, nuevaLineaDocumento,
        leerDocumentos, doc, listarProveedores, tipoCambio, detalleDocN,
        loader, bloqueo, eliminarDocumento, periodoD, eliminarLineaAbonoNuevo,
        cuentaBan, fechaFinal, agregarLinea, list_doc,
        idMoneda, cambio, proveedorD } = props;

    let autoFocus = true;

    const [nombre, setNombre] = useState('');

    const tipos = [
        {
            value: 'PAGO A PROVEEDORES',
            label: 'PAGO A PROVEEDORES'
        },
        {
            value: 'PAGOS VARIOS',
            label: 'PAGOS VARIOS'
        },
        {
            value: 'ANTICIPO A PROVEEDORES',
            label: 'ANTICIPO A PROVEEDORES'
        },
    ];

    const [negociable, setNegociable] = useState(false);
    const [tipo, setTipo] = useState(false);
    const [pagoD, setPagoD] = useState(false);
    const [editarT, setEditarT] = useState(true);
    const [proveedor, setProveedor] = useState('');

    const [tipoCambioD, setTipoCambioD] = useState(1.000000);
    const [tipoCambioED, setTipoCambioED] = useState(1.000000);

    const onCheckboxClickedNegociable = (idx, isChecked) => {
        setNegociable(isChecked);
    }

    let concepto = localStorage.getItem('concepto');

    const handleChange = (e) => {
        if (editar === true ){
            setEditarT(false)
            setTipo(e.target.value);
            if (e.target.value === 'PAGO A PROVEEDORES') {
                setPagoD(true);
                localStorage.setItem('concepto', 'PAGO A PROVEEDORES');
            }
            if (e.target.value === 'PAGOS VARIOS') {
                setPagoD(false);
                localStorage.setItem('concepto', 'PAGOS VARIOS');
            }
            if (e.target.value === 'ANTICIPO A PROVEEDORES') {
                setPagoD(false);
                localStorage.setItem('concepto', 'ANTICIPO A PROVEEDORES');
            }
        }else{
            setTipo(e.target.value);
            if (e.target.value === 'PAGO A PROVEEDORES') {
                setPagoD(true);
                localStorage.setItem('concepto', 'PAGO A PROVEEDORES');
            }
            if (e.target.value === 'PAGOS VARIOS') {
                setPagoD(false);
                localStorage.setItem('concepto', 'PAGOS VARIOS');
            }
            if (e.target.value === 'ANTICIPO A PROVEEDORES') {
                setPagoD(false);
                localStorage.setItem('concepto', 'ANTICIPO A PROVEEDORES');
            }
        }
    }

    const estilo = {
        overflow: "auto",
        height: "200px",

    };
    
    let num = localStorage.getItem('ck');
    const [numeroCk, setNumeroCk] = useState(num);
    
    const handleOnChange = value => {
        if (editar === true ){
            setProveedor(value.value);
            if (localStorage.getItem('concepto') === 'PAGO A PROVEEDORES'){
                if (detalleCK.length > 0){
                    if (value.value === proveedorD){
                        let nombreCK = value.label.split('-');
                        setNombre(nombreCK[1].trim());
                        localStorage.setItem('ProveedorCK', nombreCK[1].trim());
                    }else{
                        Swal.fire({
                            title: 'Cheques',
                            text: 'Si cambia de cliente debe de quitar los documentos agregados',
                            type: 'error',
                        })
                    }
                }else{
                    leerDocumentos(value.value, fechaFinal, cambio, idMoneda);
                    let nombreCK = value.label.split('-');
                    setNombre(nombreCK[1].trim());
                    localStorage.setItem('ProveedorCK', nombreCK[1].trim());
                }
            }
        }else{
            if (localStorage.getItem('concepto') === 'PAGO A PROVEEDORES'){
                leerDocumentos(value.value, fechaFinal, cuentaBan.cambio, cuentaBan.moneda);
            }
            
            let nombreCK = value.label.split('-');
            setNombre(nombreCK[1].trim());
            localStorage.setItem('ProveedorCK', nombreCK[1].trim());
        }
    };
    
    return (
        <div>
            {crear === false && editar == false &&
                <div className='row mb-2'>
                    <div className='col-3'>
                        <Field
                            name="cuenta"
                            placeholder="Cuenta"
                            className="form-control"
                            component={renderField}
                            disabled={bloqueo}
                            msj="Cuenta"
                        />
                    </div>
                    <div className='col-3'>
                        <Field
                            name="banco"
                            placeholder="Banco"
                            className="form-control"
                            component={renderField}
                            disabled={bloqueo}
                            msj="Banco"
                        />
                    </div>
                    <div className='col-3'>
                        <Field
                            name="moneda"
                            placeholder="Moneda"
                            className="form-control"
                            component={renderField}
                            disabled={bloqueo}
                            msj="Moneda"
                        />
                    </div>
                    <div className='col-3'>
                        <Field
                            name="tipo"
                            placeholder="Tipo"
                            className="form-control"
                            component={renderField}
                            disabled={bloqueo}
                            msj="Tipo"
                        />
                    </div>
                </div>

            }
            {(crear === true || editar == true) &&
                <div className='row mb-2'>
                    <div className='col-3'>
                        <div className="form-floating">
                            <input
                                placeholder="Cuenta"
                                type="text"
                                autocomplete="off"
                                name="cuenta"
                                className="form-control"
                                value={editar ? lectura.cuenta : cuentaBan.numero_cuenta}
                                disabled={true}
                            />
                            <label className='form-label' htmlFor="cuenta">
                                Cuenta
                            </label>
                        </div>
                    </div>
                    <div className='col-3'>
                        <div className="form-floating">
                            <input
                                placeholder="Banco"
                                type="text"
                                autocomplete="off"
                                name="banco"
                                className="form-control"
                                value={editar ? lectura.banco : cuentaBan.bancoNombre}
                                disabled={true}
                            />
                            <label className='form-label' htmlFor="banco">
                                Banco
                            </label>
                        </div>
                    </div>
                    <div className='col-3'>
                        <div className="form-floating">
                            <input
                                placeholder="Moneda"
                                type="text"
                                autocomplete="off"
                                name="moneda"
                                className="form-control"
                                value={editar? lectura.moneda : cuentaBan.monedaN}
                                disabled={true}
                            />
                            <label className='form-label' htmlFor="moneda">
                                Moneda
                            </label>
                        </div>
                    </div>
                    <div className='col-3'>
                        <div className="form-floating">
                            <input
                                placeholder="Tipo"
                                type="text"
                                autocomplete="off"
                                name="tipoCB"
                                className="form-control"
                                value={editar ? lectura.tipo : cuentaBan.tipo}
                                disabled={true}
                            />
                            <label className='form-label' htmlFor="tipoCB">
                                Tipo
                            </label>
                        </div>
                    </div>
                </div>
            }
            <div className='row mb-2'>
                <div className='col-3'>
                    <Field
                        autoFocus={autoFocus}
                        disabled={bloqueo}
                        name="fechaRegistro"
                        component={renderDayPickerB}
                        msj="Fecha Registro"
                    />
                </div>
                {crear === false && editar == false &&
                    <div className='col-3'>
                        <Field
                            name="numero_cheque"
                            placeholder="Numero Cheque"
                            className="form-control"
                            component={renderNumber}
                            disabled={bloqueo}
                            msj="Numero cheque"
                        />
                    </div>
                }
                {(crear === true) &&
                    <div className='col-3 mb-2'>
                        <div className="form-floating">
                            <input
                                placeholder="Numero cheque"
                                type="number"
                                autocomplete="off"
                                name="numeroCheque"
                                className="form-control"
                                value={numeroCk}
                                onChange={e => { setNumeroCk(e.target.value); localStorage.setItem('numeroCheque', e.target.value); }}
                                disabled={editar ? true : false}
                            />
                            <label className='form-label' htmlFor="proveedor">
                                Numero cheque
                            </label>
                        </div>
                    </div>
                }
                {editar === true &&
                    <div className='col-3'>
                        <Field
                            name="numero_cheque"
                            placeholder="Numero Cheque"
                            className="form-control"
                            component={renderNumber}
                            disabled={true}
                            msj="Numero cheque"
                        />
                    </div>
                }
                <div className='col-3'>
                    <Field
                        name="total"
                        placeholder="Total"
                        className="form-control"
                        component={renderCurrencyFloat}
                        disabled={bloqueo}
                        msj="Total"
                    />
                </div>
                
                {(crear === true) && (
                    <div>
                    {cuentaBan.cambio === 'S' &&
                        <div className='row'>
                            <div className='col-3'>
                                <div className="form-floating">
                                    <NumberFormat
                                        className={classNames('form-control')}
                                        decimalScale={6}
                                        fixedDecimalScale
                                        placeholder="Tipo de cambio"
                                        value={tipoCambioD}
                                        thousandSeparator
                                        onValueChange={(values) => {
                                            setTipoCambioD(values.value)
                                            localStorage.setItem('TC_CK', tipoCambioD)
                                        }}
                                    />
                                    <label className='form-label' htmlFor="cuenta">
                                        Tipo de cambio
                                    </label>
                                </div>
                            </div>
                            <div className='col-3 mt-2'>
                                <button
                                    className='btn mr-2 mb-3 btn-secondary'
                                    onClick={() => {
                                        let tc = tipoCambio(periodoD, cuentaBan.cambio);
                                        if (tc === undefined){
                                            setTipoCambioD('1.000000');
                                        }else{
                                            tc.then(d => { 
                                                if (d === undefined){
                                                    setTipoCambioD('1.000000');
                                                }else{
                                                    setTipoCambioD(d);
                                                    localStorage.setItem('TC_CK', d)
        
                                                }
                                            });
                                        }
                                    }}
                                >
                                    Buscar tipo de cambio
                                </button>
                            </div>
                        </div>
                    }
                    </div>
                )}

                {crear === false && editar == false &&
                <div className='col-3'>
                    {lectura.cambio === 'S' &&
                        <Field
                            name="tipo_cambio"
                            placeholder="Tipo de cambio"
                            className="form-control"
                            component={renderCurrencyFloatTC}
                            disabled={bloqueo}
                            msj="Tipo de cambio"
                        />
                    }
                    </div>
                }
                {(crear === false && editar == false) ? (
                    <div className='col-3 mt-3'>
                        <Field
                            name="negociable"
                            disabled={true}
                            label="Negociable"
                            component={renderFieldCheck}
                            onChange={onCheckboxClickedNegociable}
                        />
                    </div>
                ) :
                    <div className='col-3 mt-3'>
                        <Field
                            name="negociable"
                            checked={negociable}
                            label="Negociable"
                            component={renderFieldCheck}
                            onChange={onCheckboxClickedNegociable}
                        />
                    </div>
                }
            </div>
            {(editar === true) && (
            <div>
                {lectura.cambio === 'S' &&
                    <div className='row mt-2 mb-2'>
                        <div className='col-3'>
                            <div className="form-floating">
                                <NumberFormat
                                    className={classNames('form-control')}
                                    decimalScale={6}
                                    fixedDecimalScale
                                    placeholder="Tipo de cambio"
                                    value={tipoCambioED}
                                    thousandSeparator
                                    onValueChange={(values) => {
                                        setTipoCambioED(values.value)
                                        localStorage.setItem('TC_CK', tipoCambioED)
                                    }}
                                />
                                <label className='form-label' htmlFor="cuenta">
                                    Tipo de cambio
                                </label>
                            </div>
                        </div>
                        <div className='col-3 mt-2'>
                            <button
                                className='btn mr-2 mb-3 btn-secondary'
                                onClick={() => {
                                    let tc = tipoCambio(periodoD, lectura.cambio);
                                    if (tc === undefined){
                                        setTipoCambioED('1.000000');
                                    }else{
                                        tc.then(d => { 
                                            if (d === undefined){
                                                setTipoCambioED('1.000000');
                                            }else{
                                                setTipoCambioED(d);
                                                localStorage.setItem('TC_CK', d)

                                            }
                                        });
                                    }
                                }}
                            >
                                Buscar tipo de cambio
                            </button>
                        </div>
                    </div>
                }
            </div>
            )}
                
            {crear === false && editar == false &&
                <div className='row mb-2'>
                    <div className='col-3'>
                        {tipos &&
                            <div className="form-floating">
                                <Field
                                    name="tipo"
                                    options={tipos}
                                    crear={crear}
                                    dato={crear === true ? 0 : lectura.concepto}
                                    component={SelectField}
                                    className="form-select"
                                    disabled={bloqueo}
                                    msj="Tipo de documento"
                                />
                            </div>
                        }
                    </div>
                    {(crear === false && editar == false) && ( concepto === 'PAGO A PROVEEDORES' || concepto === 'ANTICIPO A PROVEEDORES' ) &&
                        <div className='w-75'>
                            <Field
                                name="proveedorNombre"
                                placeholder="Nombre Proveedor"
                                className="form-control"
                                component={renderField}
                                disabled={bloqueo}
                                msj="Nombre Proveedor"
                            />
                        </div>
                    }
                </div>
            }
            {crear === true &&
                <div className='row mb-2'>
                    <div className='col-3'>
                        <div className="form-floating">
                            <select className="form-select" id="tipo" name="tipo"
                                value={editar === true ? lectura.concepto : tipo} onChange={handleChange} >
                                <option selected>Seleccionar...</option>
                                {tipos.map(
                                    tip => <option key={tip.value} value={tip.value}
                                    >{tip.label}
                                    </option>)
                                }
                            </select>
                            <label className='form-label' htmlFor="mes">Tipo de documento</label>
                        </div>
                    </div>
                    <div className='w-75'>
                        <Field
                            name="proveedor_documento"
                            placeholder="Proveedor..."
                            className="form-control-find"
                            component={AsyncSelectField}
                            loadOptions={listarProveedores}
                            onChange={handleOnChange}
                            msj="Proveedor"
                        />
                    </div>
                </div>
            }
            {editar == true &&
                <div className='row mb-2'>
                    <div className='col-3'>
                        <div className="form-floating">
                            <select className="form-select" id="tipo" name="tipo"
                                value={editarT === true ? lectura.concepto : tipo} onChange={handleChange} >
                                <option selected>Seleccionar...</option>
                                {tipos.map(
                                    tip => <option key={tip.value} value={tip.value}
                                    >{tip.label}
                                    </option>)
                                }
                            </select>
                            <label className='form-label' htmlFor="mes">Tipo de documento</label>
                        </div>
                    </div>
                    {editar && ( concepto === 'PAGO A PROVEEDORES' || concepto === 'ANTICIPO A PROVEEDORES' ) &&
                        <div className='row col-9'>
                            <div className='w-75'>
                                <Field
                                    name="proveedorNombre"
                                    placeholder="Codigo Proveedor"
                                    className="form-control"
                                    component={renderField}
                                    disabled={true}
                                    msj="Nombre Proveedor"
                                />
                            </div>
                            {proveedor === '' && detalleCK.length === 0 &&
                                <div className='w-75'>
                                    <Field
                                        name="proveedor_documento"
                                        placeholder="Proveedor..."
                                        className="form-control-find"
                                        component={AsyncSelectField}
                                        loadOptions={listarProveedores}
                                        onChange={handleOnChange}
                                        msj="Proveedor"
                                    />
                                </div>
                            }
                            {proveedor  && detalleCK.length === 0 &&
                                <div className='w-75'>
                                    <Field
                                        name="proveedor_documento"
                                        placeholder="Proveedor..."
                                        className="form-control-find"
                                        component={AsyncSelectField}
                                        loadOptions={listarProveedores}
                                        onChange={handleOnChange}
                                        msj="Proveedor"
                                    />
                                </div>
                            }
                        </div>

                    }
                </div>
            }
            {crear === false && editar == false  && 
                <div className='mb-2'>
                    <Field
                        name="nombre"
                        placeholder="Nombre"
                        component={renderField}
                        className="form-control"
                        disabled={bloqueo}
                        msj="Nombre"
                    />
                </div>
            }
            {(crear === true) &&
                <div className='mb-2'>
                    <div className="form-floating">
                        <input
                            placeholder="Nombre"
                            type="text"
                            autocomplete="off"
                            name="nombre"
                            className="form-control"
                            value={editar && nombre === '' ? lectura.nombre : nombre }
                            onChange={e => { setNombre(e.target.value); localStorage.setItem('ProveedorCK', e.target.value); }}
                            disabled={false}
                        />
                        <label className='form-label' htmlFor="proveedor">
                            Nombre
                        </label>
                    </div>
                </div>
            }
            {editar == true &&
                <div className='mb-2'>
                    <div className="form-floating">
                        <input
                            placeholder="Nombre"
                            type="text"
                            autocomplete="off"
                            name="nombre"
                            className="form-control"
                            value={editar && nombre === '' ? lectura.nombre : nombre }
                            onChange={e => { setNombre(e.target.value); localStorage.setItem('ProveedorCK', e.target.value); }}
                            disabled={false}
                        />
                        <label className='form-label' htmlFor="proveedor">
                            Nombre
                        </label>
                    </div>
                </div>
            }
            <div className='mb-2'>
                <Field
                    name="descripcion"
                    placeholder="Descripcion"
                    component={renderField}
                    className="form-control"
                    disabled={bloqueo}
                    msj="Referencia"
                />
            </div>
            {doc && editar && concepto === 'PAGO A PROVEEDORES' &&
                <div>
                    <h5 className="p-2 bg-secondary title mt-1">Documentos con saldo</h5>
                    <div style={estilo}>
                        <Grid
                            hover
                            striped
                            data={doc}
                            loading={loader}
                            headerStyle={{ background: 'black' }}
                        //onSortChange={onSortChange} 
                        >
                            <TableHeaderColumn
                                isKey
                                dataField="fecha"
                                dataSort
                                dataFormat={(cell, row) => {
                                    return moment(cell).format("DD/MM/YYYY");
                                }}
                                thStyle={
                                    { color: 'white' }}
                                tdStyle={
                                    { color: 'white' }}
                            >
                                Fecha
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="serie"
                                dataSort
                                thStyle={
                                    { color: 'white' }}
                                tdStyle={
                                    { color: 'white' }}
                            >
                                Serie
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="numero"
                                dataSort
                                thStyle={
                                    { color: 'white' }}
                                tdStyle={
                                    { color: 'white' }}
                            >
                                Numero
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="proveedorN"
                                width="350"
                                dataSort
                                thStyle={
                                    { color: 'white' }}
                                tdStyle={
                                    { color: 'white' }}
                            >
                                Proveedor
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="total"
                                headerAlign="center"
                                dataAlign='right'
                                dataFormat={(cell, row) => {
                                    if (parseFloat(cell) === 0.00) {
                                        return ''
                                    } else {
                                        return new Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(cell);
                                    }
                                }}
                                dataSort
                                thStyle={
                                    { color: 'white' }}
                                tdStyle={
                                    { color: 'white' }}
                            >
                                Total
                            </TableHeaderColumn>
                        </Grid>
                    </div>
                    <div className='row mb-2'>
                        <div className='col-8 mt-2'>
                            <Field
                                name="documento"
                                placeholder="Documento..."
                                className="form-control-find"
                                loadOptions={list_doc}
                                component={AsyncSelectFieldIn}
                                msj="Documento"
                            />
                        </div>
                        <div className='col-3 mt-2'>
                            <div className="form-floating">
                                <Field
                                    name="abono"
                                    placeholder="Abono"
                                    className="form-control"
                                    component={renderCurrencyFloat}
                                    disabled={false}
                                    msj="Abono"
                                />
                            </div>
                        </div>
                    </div>
                    <Contenido>
                        <button
                            className='btn mr-2 mb-3 btn-primary'
                            onClick={() => nuevaLineaDocumento(periodoD)}
                        >
                            Agregar documento
                        </button>
                        <div className='row mb-2'>
                            <div className='col-6'>
                                <div className="form-floating">
                                    <Field
                                        name="diferencia"
                                        placeholder="Diferencia"
                                        className="form-control"
                                        component={renderCurrencyFloat}
                                        disabled={true}
                                        msj="Diferencia"
                                    />
                                </div>
                            </div>
                            <div className='col-6'>
                                <div className="form-floating">
                                    <Field
                                        name="totalAbono"
                                        placeholder="Total Abono"
                                        className="form-control"
                                        component={renderCurrencyFloat}
                                        disabled={true}
                                        msj="Total Abono"
                                    />
                                </div>
                            </div>
                        </div>
                    </Contenido>

                </div>
            }
            {pagoD && editar === false &&
                <div>
                    <h5 className="p-2 bg-secondary title mt-1">Documentos con saldo</h5>
                    <div style={estilo}>
                        <Grid
                            hover
                            striped
                            data={doc}
                            loading={loader}
                            headerStyle={{ background: 'black' }}

                        >
                            <TableHeaderColumn
                                isKey
                                dataField="fecha"
                                dataSort
                                dataFormat={(cell, row) => {
                                    return moment(cell).format("DD/MM/YYYY");
                                }}
                                thStyle={
                                    { color: 'white' }}
                                tdStyle={
                                    { color: 'white' }}
                            >
                                Fecha
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="serie"
                                dataSort
                                thStyle={
                                    { color: 'white' }}
                                tdStyle={
                                    { color: 'white' }}
                            >
                                Serie
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="numero"
                                dataSort
                                thStyle={
                                    { color: 'white' }}
                                tdStyle={
                                    { color: 'white' }}
                            >
                                Numero
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="proveedorN"
                                width="350"
                                dataSort
                                thStyle={
                                    { color: 'white' }}
                                tdStyle={
                                    { color: 'white' }}
                            >
                                Proveedor
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="total"
                                headerAlign="center"
                                dataAlign='right'
                                dataFormat={(cell, row) => {
                                    if (parseFloat(cell) === 0.00) {
                                        return ''
                                    } else {
                                        return new Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(cell);
                                    }
                                }}
                                dataSort
                                thStyle={
                                    { color: 'white' }}
                                tdStyle={
                                    { color: 'white' }}
                            >
                                Total
                            </TableHeaderColumn>
                        </Grid>
                    </div>
                    <div className='row mb-2'>
                        <div className='col-8 mt-2'>
                            <Field
                                name="documento"
                                placeholder="Documento..."
                                className="form-control-find"
                                loadOptions={list_doc}
                                component={AsyncSelectFieldIn}
                                msj="Documento"
                            />
                        </div>
                        <div className='col-2 mt-2'>
                            <div className="form-floating">
                                <Field
                                    name="abono"
                                    placeholder="Abono"
                                    className="form-control"
                                    component={renderCurrencyFloat}
                                    disabled={false}
                                    msj="Abono"
                                />
                            </div>
                        </div>
                    </div>
                    {(crear === true) &&
                        <Contenido>
                            <button
                                className='btn mr-2 mb-3 btn-primary'
                                onClick={() => agregarLinea(periodoD)}
                            >
                                Agregar documento
                            </button>
                            <div className='row mb-2'>
                                <div className='col-6'>
                                    <div className="form-floating">
                                        <Field
                                            name="diferencia"
                                            placeholder="Diferencia"
                                            className="form-control"
                                            component={renderCurrencyFloat}
                                            disabled={true}
                                            msj="Diferencia"
                                        />
                                    </div>
                                </div>
                                <div className='col-6'>
                                    <div className="form-floating">
                                        <Field
                                            name="totalAbono"
                                            placeholder="Total Abono"
                                            className="form-control"
                                            component={renderCurrencyFloat}
                                            disabled={true}
                                            msj="Total Abono"
                                        />
                                    </div>
                                </div>
                            </div>
                        </Contenido>
                    }

                    {(crear === true) &&
                        <div>
                            <h5 className="p-2 bg-secondary title mt-1">Documentos agregados</h5>
                            <div style={estilo}>
                                <TablaDetalle
                                    detalle={detalleDocN}
                                    eliminarDocumento={eliminarLineaAbonoNuevo}
                                />
                            </div>
                        </div>
                    }
                </div>
            }
            {crear === false && editar === false &&
                (lectura.concepto === 'PAGO A PROVEEDORES' &&
                    <div>
                        <h5 className="p-2 bg-secondary title mt-1">Documentos agregados</h5>
                        <div style={estilo}>
                            <TablaVerDetalle
                                detalle={detalleCK}
                            />
                        </div>
                    </div>
                )
            }
            {(editar === true) && concepto === 'PAGO A PROVEEDORES' &&

                <div>
                    <h5 className="p-2 bg-secondary title mt-1">Documentos agregados</h5>
                    <div style={estilo}>
                        <TablaDetalleMod
                            detalle={detalleCK}
                            eliminarDocumento={eliminarDocumento}
                        />
                    </div>
                    <br />
                </div>

            }
            
        </div>

    );
}

ChequesForm.propTypes = {
    funcionEnvio: PropTypes.func,
    crear: PropTypes.bool,
    editar: PropTypes.bool,
    lectura: PropTypes.object,
    bancos: PropTypes.object,
    listaM: PropTypes.object,
    listarProveedores: PropTypes.object,
    leerDocumentos: PropTypes.func,
    doc: PropTypes.object,
    loader: PropTypes.bool,
    bloqueo: PropTypes.bool,
    detalleDoc: PropTypes.object,
    eliminarDocumento: PropTypes.func,
    cuentaBan: PropTypes.object,
    ck: PropTypes.int,
    detalleCK: PropTypes.object,
    fechaInicio: PropTypes.string,
    fechaFinal: PropTypes.string,
};

export default reduxForm({
    form: 'FormCheques',
})(ChequesForm);

const Contenido = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

`;